(function () {
  var originalTextNodes = new WeakMap();
  var trackedTextNodes = [];
  var hiddenAttribute = "data-laboo-us-size-hidden";
  var originalDisplayAttribute = "data-laboo-original-display";

  var sizeLabelMap = [
    { pattern: /\bA4\s*[-\u2013]\s*21\s*[x×]\s*29[.,]7\s*cm\b/gi, label: "8 x 12 in" },
    { pattern: /\b13\s*[x×]\s*18\s*cm\b(?:\s*=\s*5\s*[x×]\s*7\s*(?:\"|in|\u201d|\u2033))?/gi, label: "5 x 7 in" },
    { pattern: /\b27\s*[x×]\s*35\s*cm\b(?:\s*=\s*11\s*[x×]\s*14\s*(?:\"|in|\u201d|\u2033))?/gi, label: "11 x 14 in" },
    { pattern: /\b30\s*[x×]\s*40\s*cm\b(?:\s*=\s*12\s*[x×]\s*16\s*(?:\"|in|\u201d|\u2033))?/gi, label: "12 x 16 in" },
    { pattern: /\b40\s*[x×]\s*50\s*cm\b(?:\s*=\s*16\s*[x×]\s*20\s*(?:\"|in|\u201d|\u2033))?/gi, label: "16 x 20 in" },
    { pattern: /\b40\s*[x×]\s*60\s*cm\b(?:\s*=\s*16\s*[x×]\s*24\s*(?:\"|in|\u201d|\u2033))?/gi, label: "16 x 24 in" },
    { pattern: /\b50\s*[x×]\s*70\s*cm\b(?:\s*=\s*20\s*[x×]\s*28\s*(?:\"|in|\u201d|\u2033))?/gi, label: "20 x 28 in" },
    { pattern: /\b60\s*[x×]\s*80\s*cm\b(?:\s*=\s*24\s*[x×]\s*32\s*(?:\"|in|\u201d|\u2033))?/gi, label: "24 x 32 in" },
    { pattern: /\b60\s*[x×]\s*90\s*cm\b(?:\s*=\s*24\s*[x×]\s*36\s*(?:\"|in|\u201d|\u2033))?/gi, label: "24 x 36 in" },
    { pattern: /\b70\s*[x×]\s*100\s*cm\b(?:\s*=\s*28\s*[x×]\s*40\s*(?:\"|in|\u201d|\u2033))?/gi, label: "28 x 40 in" },
    { pattern: /\b75\s*[x×]\s*100\s*cm\b(?:\s*=\s*30\s*[x×]\s*40\s*(?:\"|in|\u201d|\u2033))?/gi, label: "30 x 40 in" },
    { pattern: /\b25\s*[x×]\s*25\s*cm\b(?:\s*=\s*10\s*[x×]\s*10\s*(?:\"|in|\u201d|\u2033))?/gi, label: "10 x 10 in" },
    { pattern: /\b30\s*[x×]\s*30\s*cm\b(?:\s*=\s*12\s*[x×]\s*12\s*(?:\"|in|\u201d|\u2033))?/gi, label: "12 x 12 in" },
    { pattern: /\b35\s*[x×]\s*35\s*cm\b(?:\s*=\s*14\s*[x×]\s*14\s*(?:\"|in|\u201d|\u2033))?/gi, label: "14 x 14 in" },
    { pattern: /\b40\s*[x×]\s*40\s*cm\b(?:\s*=\s*16\s*[x×]\s*16\s*(?:\"|in|\u201d|\u2033))?/gi, label: "16 x 16 in" },
    { pattern: /\b45\s*[x×]\s*45\s*cm\b(?:\s*=\s*18\s*[x×]\s*18\s*(?:\"|in|\u201d|\u2033))?/gi, label: "18 x 18 in" },
    { pattern: /\b50\s*[x×]\s*50\s*cm\b(?:\s*=\s*20\s*[x×]\s*20\s*(?:\"|in|\u201d|\u2033))?/gi, label: "20 x 20 in" },
    { pattern: /\b70\s*[x×]\s*70\s*cm\b(?:\s*=\s*28\s*[x×]\s*28\s*(?:\"|in|\u201d|\u2033))?/gi, label: "28 x 28 in" }
  ];

  var hiddenUSSizePattern = /A(?:0|1|2|3)\s*[-\u2013]\s*[\d.,]+\s*[x×]\s*[\d.,]+\s*cm\b/i;
  var convertibleSizePattern = /\b(?:A4\s*[-\u2013]\s*)?\d+(?:[.,]\d+)?\s*[x×]\s*\d+(?:[.,]\d+)?\s*cm\b/i;

  var filterScopeSelector = [
    ".facets",
    ".mobile-facets",
    ".facets-container",
    "facet-filters-form",
    ".laboo-filters",
    "#snize_results",
    ".snize",
    ".snize-modal-content",
    ".snize-product-filter-container",
    ".snize-product-filters-list",
    ".snize-product-filters-block",
    ".snize-filter-panel",
    ".snize-filters-sidebar",
    "[class*='snize']",
    "[id*='snize']"
  ].join(",");

  var filterOptionSelector = [
    "li",
    "label",
    ".facets__item",
    ".mobile-facets__item",
    ".list-menu__item",
    ".snize-filter-value",
    ".snize-filter-option",
    ".snize-filter-item",
    ".snize-product-filters-list-item",
    ".snize-product-filters-list-li",
    "[data-filter-value]"
  ].join(",");

  var navigationScopeSelector = [
    "header",
    ".site-header",
    ".mobile-navigation",
    ".mobile-main-menu",
    ".mobile-submenu",
    ".submenu",
    ".custom-mega-menu",
    ".mega-menu",
    ".drawer--menu",
    "[data-menu]"
  ].join(",");

  var filterRootSelector = [
    ".facets-container",
    "facet-filters-form",
    ".mobile-facets",
    ".laboo-filters",
    "#snize_results",
    ".snize-modal-content",
    ".snize-product-filter-container",
    ".snize-filter-panel",
    ".snize-filters-sidebar"
  ].join(",");

  var searchaniseRootSelector = [
    "#snize_results",
    ".snize-modal-content",
    ".snize-ac-results",
    ".snize-main-panel"
  ].join(",");

  function activeCountry() {
    return String(
      (window.LabooMarket && window.LabooMarket.country) ||
      (window.Shopify && window.Shopify.country) ||
      document.documentElement.dataset.labooCountry ||
      ""
    ).toUpperCase();
  }

  function isUSMarket() {
    return ["US", "CA"].indexOf(activeCountry()) !== -1;
  }

  function normalizedText(element) {
    return String(element && element.textContent ? element.textContent : "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function replaceSizeText(text) {
    var output = text;
    sizeLabelMap.forEach(function (entry) {
      output = output.replace(entry.pattern, entry.label);
    });
    return output;
  }

  function formatSizeLabel(value) {
    var original = String(value || "").trim();
    if (!isUSMarket()) return original;
    if (hiddenUSSizePattern.test(original)) return null;
    return replaceSizeText(original);
  }

  function isInsideFilterScope(element) {
    return Boolean(
      element &&
      element.closest &&
      element.closest(filterScopeSelector) &&
      !element.closest(navigationScopeSelector)
    );
  }

  function closestFilterOption(element) {
    if (!element || !element.closest) return null;

    var option = element.closest(filterOptionSelector);
    if (!option || !isInsideFilterScope(option)) return null;

    if (option.tagName === "LABEL") {
      var row = option.closest("li, .facets__item, .mobile-facets__item");
      if (row && isInsideFilterScope(row)) {
        option = row;
      }
    }

    /*
      Searchanise and Shopify both render size filter values as compact rows.
      This guard prevents hiding an entire filter panel if an app changes markup.
    */
    if (normalizedText(option).length > 220) return null;

    return option;
  }

  function hideOption(option) {
    if (!option || option.getAttribute(hiddenAttribute) === "true") return;
    option.setAttribute(originalDisplayAttribute, option.style.display || "");
    option.setAttribute(hiddenAttribute, "true");
    option.hidden = true;
    option.style.display = "none";

    option.querySelectorAll("label, input").forEach(function (child) {
      child.setAttribute(hiddenAttribute, "true");
    });
  }

  function restoreAll() {
    document.querySelectorAll("[" + hiddenAttribute + "='true']").forEach(function (element) {
      element.hidden = false;
      element.style.display = element.getAttribute(originalDisplayAttribute) || "";
      element.removeAttribute(hiddenAttribute);
    });

    trackedTextNodes.forEach(function (node) {
      if (node && node.parentNode && originalTextNodes.has(node)) {
        node.nodeValue = originalTextNodes.get(node);
      }
    });

    originalTextNodes = new WeakMap();
    trackedTextNodes = [];
  }

  function saveOriginalTextNode(node) {
    if (!originalTextNodes.has(node)) {
      originalTextNodes.set(node, node.nodeValue);
      trackedTextNodes.push(node);
    }
  }

  function normalizeTextNode(node) {
    var parent = node.parentElement;
    if (!parent || !isInsideFilterScope(parent)) return;

    var original = originalTextNodes.has(node) ? originalTextNodes.get(node) : node.nodeValue;
    if (!hiddenUSSizePattern.test(original) && !convertibleSizePattern.test(original)) return;

    var option = closestFilterOption(parent);
    if (option && hiddenUSSizePattern.test(normalizedText(option))) {
      hideOption(option);
      return;
    }

    var replaced = replaceSizeText(original);
    if (replaced !== original) {
      saveOriginalTextNode(node);
      node.nodeValue = replaced;
    }
  }

  function normalizeFilterOption(option) {
    if (!isInsideFilterScope(option)) return;

    var row = option.tagName === "LABEL" ? option.closest("li, .facets__item, .mobile-facets__item") : null;
    if (row && isInsideFilterScope(row)) {
      option = row;
    }

    var text = normalizedText(option);
    if (!text || (!hiddenUSSizePattern.test(text) && !convertibleSizePattern.test(text))) return;

    if (hiddenUSSizePattern.test(text)) {
      hideOption(option);
      return;
    }

    var walker = document.createTreeWalker(option, NodeFilter.SHOW_TEXT);
    var nodes = [];

    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(normalizeTextNode);
  }

  function refresh() {
    restoreAll();
    styleSearchaniseNoResultButtons();

    if (!isUSMarket()) {
      return;
    }

    document.querySelectorAll(filterRootSelector).forEach(function (scope) {
      if (!isInsideFilterScope(scope)) return;

      scope.querySelectorAll(filterOptionSelector).forEach(normalizeFilterOption);

      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      var nodes = [];

      while (walker.nextNode()) {
        nodes.push(walker.currentNode);
      }

      nodes.forEach(normalizeTextNode);
    });
  }

  function styleSearchaniseNoResultButtons() {
    document.querySelectorAll(searchaniseRootSelector).forEach(function (root) {
      root.querySelectorAll("a, button, [role='button'], .button, [class*='button'], [class*='Button']").forEach(function (element) {
        var text = normalizedText(element).toUpperCase();
        var href = String(element.getAttribute && element.getAttribute("href") || "");
        var isAllProductsLink = /\/collections\/all(?:[?#]|$)/.test(href);

        if (/^SEE ALL PRODUCTS\b/.test(text) || isAllProductsLink) {
          element.classList.add("laboo-searchanise-see-all-button");
          element.style.setProperty("background", "#000", "important");
          element.style.setProperty("background-color", "#000", "important");
          element.style.setProperty("border-color", "#000", "important");
          element.style.setProperty("color", "#fff", "important");
        }
      });
    });
  }

  function addSearchaniseContainmentStyles() {
    if (document.getElementById("laboo-searchanise-mobile-containment")) {
      return;
    }

    var style = document.createElement("style");
    style.id = "laboo-searchanise-mobile-containment";
    style.textContent = [
      ".laboo-searchanise-see-all-button,",
      ".laboo-searchanise-see-all-button:hover,",
      ".laboo-searchanise-see-all-button:focus {",
      "  background: #000 !important;",
      "  background-color: #000 !important;",
      "  border-color: #000 !important;",
      "  color: #fff !important;",
      "}",
      ".laboo-searchanise-see-all-button svg,",
      ".laboo-searchanise-see-all-button svg *,",
      ".laboo-searchanise-see-all-button path {",
      "  color: currentColor !important;",
      "  stroke: currentColor !important;",
      "}",
      "@media (max-width: 767px) {",
      "  body #snize_results,",
      "  body .snize,",
      "  body .snize-main-panel,",
      "  body .snize-search-results,",
      "  body .snize-search-results-main-content,",
      "  body .snize-search-results-content,",
      "  body .snize-products,",
      "  body .snize-products-list {",
      "    box-sizing: border-box !important;",
      "    max-width: 100vw !important;",
      "    width: 100% !important;",
      "    margin-left: 0 !important;",
      "    margin-right: 0 !important;",
      "    transform: none !important;",
      "    overflow-x: hidden !important;",
      "  }",
      "  body .snize-product {",
      "    box-sizing: border-box !important;",
      "    max-width: 100% !important;",
      "  }",
      "  body [data-laboo-us-size-hidden='true'] {",
      "    display: none !important;",
      "  }",
      "}"
    ].join("\n");
    document.head.appendChild(style);
  }

  var scheduled = false;
  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      refresh();
    });
  }

  function isRelevantNode(node) {
    if (!node) return false;

    var element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element || !element.matches) return false;

    return element.matches(filterRootSelector + "," + searchaniseRootSelector) ||
      Boolean(element.closest(filterRootSelector + "," + searchaniseRootSelector)) ||
      Boolean(element.querySelector(filterRootSelector + "," + searchaniseRootSelector));
  }

  function relevantMutations(mutations) {
    return mutations.some(function (mutation) {
      if (isRelevantNode(mutation.target)) return true;

      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return isRelevantNode(node);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    addSearchaniseContainmentStyles();
    refresh();
  });

  document.addEventListener("click", function (event) {
    if (!isRelevantNode(event.target)) return;
    window.setTimeout(scheduleRefresh, 80);
  }, true);

  document.addEventListener("change", function (event) {
    if (!isRelevantNode(event.target)) return;
    window.setTimeout(scheduleRefresh, 80);
  }, true);

  new MutationObserver(function (mutations) {
    if (relevantMutations(mutations)) scheduleRefresh();
  }).observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener("shopify:section:load", scheduleRefresh);

  window.LabooMarketSizeLabels = {
    refresh: refresh,
    format: formatSizeLabel,
    isUSMarket: isUSMarket
  };
})();
